// extracted by mini-css-extract-plugin
module.exports = {"container":"e_I4","icon":"e_J4"};